import { useState, useEffect } from 'react';
import { useTheme } from '../context/ThemeContext';
import './FeesPage.css';

const FeesPage = () => {
  const { theme } = useTheme();
  const [expandedCard, setExpandedCard] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  // Check if device is mobile
  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);
    
    return () => {
      window.removeEventListener('resize', checkIsMobile);
    };
  }, []);

  const feeStructure = [
    {
      class: 'Class 12',
      price: 1200,
      subjects: ['Physics', 'Chemistry', 'Mathematics', 'Commerce'],
      duration: 'Per subject per month'
    },
    {
      class: 'Class 11 ',
      price: 1000,
      subjects: ['Physics', 'Chemistry', 'Mathematics', 'Commerce'],
      duration: 'Per subject per month'
    },
    {
      class: 'Class 10',
      price: 800,
      subjects: ['Math', 'English', 'Science', 'S.S.T'],
      duration: 'Per subject per month'
    },
    {
      class: 'Class 9',
      price: 700,
      subjects: ['Math', 'English', 'Science', 'S.S.T'],
      duration: 'Per subject per month'
    },
    {
      class: 'Class 8',
      price: 2000,
      subjects: ['Math', 'English', 'Science', 'S.S.T'],
      duration: 'All four subjects (complete package)'
    }
  ];

  const toggleCard = (index) => {
    if (!isMobile) return; // Only allow toggling on mobile
    
    if (expandedCard === index) {
      setExpandedCard(null);
    } else {
      setExpandedCard(index);
    }
  };

  return (
    <div  className="fees-page" data-theme={theme}>
      <div className="fees-header">
        <h1>Fee Structure</h1>
        <p className="subtitle">Transparent pricing for quality education</p>
      </div>

      <div className="fee-cards-container">
        {feeStructure.map((tier, index) => (
          <div 
            key={index} 
            className={`fee-card ${theme} ${isMobile && expandedCard === index ? 'expanded' : ''}`}
            onClick={() => toggleCard(index)}
          >
            <div className="card-main-content">
              <div className="class-name">
                <h2>{tier.class}</h2>
              </div>
              <div className="price-container">
                <div className="price">₹{tier.price}</div>
                <div className="price-desc">
                  {tier.class === 'Class 8' ? '/month (all subjects)' : '/month per subject'}
                </div>
              </div>
            </div>
            
            <div className="card-details">
              <div className="subjects">
                <h3>Includes:</h3>
                <ul>
                  {tier.subjects.map((subject, i) => (
                    <li key={i}>{subject}</li>
                  ))}
                </ul>
              </div>
              
              <div className="duration">
                <p>{tier.duration}</p>
              </div>
            </div>
            
            {isMobile && (
              <div className="mobile-tap-hint">
                <span>Tap for details</span>
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="additional-info">
        <h3>Additional Information:</h3>
        <ul>
          <li>Fees are payable monthly in advance</li>
          <li>Study materials included in the fees</li>
          <li>Regular assessments and progress reports</li>
          <li>Discount available for sibling enrollments</li>
          <li>Flexible payment options available</li>
        </ul>
      </div>
    </div>
  );
};

export default FeesPage;